import common from './common';
import header from './header';
import registration from './registration';
import participants from './participants';
import members from './members';
import tournament from './tournament';
import bracket from './bracket';
import admin from './admin';

const namespaces = { common, header, registration, participants, members, tournament, bracket, admin };

/** { ko: { common: {...}, header: {...} }, en: {...} } */
const messages = { ko: {}, en: {} };
Object.entries(namespaces).forEach(([name, table]) => {
  messages.ko[name] = table.ko;
  messages.en[name] = table.en;
});

export default messages;
